export class BananiAuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BananiAuthError';
  }
}

export const getErrorMessage = (error: unknown) => {
  if (error instanceof BananiAuthError) return error.message;

  return 'An error occurred. Please try again';
};
